import { render, staticRenderFns } from "./importDeclare.vue?vue&type=template&id=2f8d2446&scoped=true&"
import script from "./importDeclare.vue?vue&type=script&lang=js&"
export * from "./importDeclare.vue?vue&type=script&lang=js&"
import style0 from "./importDeclare.vue?vue&type=style&index=0&id=2f8d2446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8d2446",
  null
  
)

component.options.__file = "importDeclare.vue"
export default component.exports